import React, {useState} from "react";
import {Button} from "../../../../index";
import {Input, Select} from "antd";
import {useViewerStore} from "../../../../../store/store";

const MoveModuleByMeasurement = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const [selectedDirection, setSelectedDirection] = useState<string | null>(null)
    const [selectedMeasurement, setSelectedMeasurement] = useState<number>(0)

    const submitMeasurement = () => {

        //Check if user has selected a direction and measurement
        if (selectedDirection === null || selectedMeasurement === 0) {
            alert('Please select direction or input measurement');
            return
        }

        sceneViewer.moveModuleDistance(selectedDirection, selectedMeasurement);

        sceneViewer.removeViewerAlert()

    }

    const directionOptions = [
        {value: 'left', label: 'Left'},
        {value: 'right', label: 'Right'},
        {value: 'top', label: 'Up'},
        {value: 'bottom', label: 'Down'},
    ]


    const handleDirectionChange = (value : string) => {
        setSelectedDirection(value)
    }

    return (
        <>
            <div className={'treeForm'}>
                <br/>
                <label htmlFor="moveSelectedModuleByMeasurementSelectDir">Select Direction : </label>
                <Select
                    id={'moveSelectedModuleByMeasurementSelectDir'}
                    placeholder={"Select Direction"}
                    onChange={handleDirectionChange}
                    options={directionOptions}
                />

                <br/>
                <label htmlFor="inchModuleMoveMeasurementInput">Input Inch Value : </label>
                <Input
                    id={"inchModuleMoveMeasurementInput"}
                    type="number"
                    value={selectedMeasurement}
                    onChange={(e) => setSelectedMeasurement(Number(e.target.value))}
                    placeholder={"Input Inch Value"}
                    name="predictValue"
                />
                <br/>
                <Button
                    id={"submitModuleMoveMeasurementBtn"}
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={submitMeasurement}
                >
                    Submit
                </Button>

            </div>

        </>
    )
}

export default MoveModuleByMeasurement